import { reactive } from 'vue';

const MAX_TOASTS = 4;
const DURATIONS_MS = { message: 7000, info: 4000, error: 6000 };

export const chatToasts = reactive([]);

let toastSeq = 0;
const timers = new Map();

export const dismissChatToast = (id) => {
	clearTimeout(timers.get(id));
	timers.delete(id);
	const index = chatToasts.findIndex((toast) => toast.id === id);
	if (index !== -1) {
		chatToasts.splice(index, 1);
	}
};

export const showChatToast = ({
	kind = 'info',
	title = '',
	subtitle = '',
	text = '',
	typeId = null,
	image = '',
	target = null,
	group = null,
}) => {
	if (group) {
		chatToasts.filter((toast) => toast.group === group).forEach((toast) => dismissChatToast(toast.id));
	}
	toastSeq += 1;
	const id = toastSeq;
	chatToasts.push({ id, kind, title, subtitle, text, typeId, image, target, group });
	while (chatToasts.length > MAX_TOASTS) {
		dismissChatToast(chatToasts[0].id);
	}
	timers.set(
		id,
		setTimeout(() => dismissChatToast(id), DURATIONS_MS[kind] || DURATIONS_MS.info)
	);
	return id;
};

export const clearChatToasts = () => {
	[...chatToasts].forEach((toast) => dismissChatToast(toast.id));
};
